<app-collaborators-invitations-list
  [invitationsPage]="myInvitations$ | async"
  [isLoading]="isLoading"
  (acceptInvitationClick)="handleAcceptInvitationClick($event)"
  (pageChange)="handlePageChange($event)" />
